module.exports = __webpack_public_path__ + "static/media/inspiration.35976ee3.jpg";